import { render, staticRenderFns } from "./EditCabang.vue?vue&type=template&id=18e76e6f&"
import script from "./EditCabang.vue?vue&type=script&lang=js&"
export * from "./EditCabang.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports